import { AuthMFASetup } from 'sections/auth/auth-forms/AuthMFASetup';
import AuthWrapper from 'sections/auth/AuthWrapper';

export function MfaSetup() {
    return (
        <AuthWrapper>
            <AuthMFASetup />
        </AuthWrapper>
    );
}
